/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withNamespaces } from "react-i18next";
import {
  ADMIN_MENUS, DEV_MENUS,
  HOMEPAGE_MENUS,
  MANAGER_MENUS,
  MENUS,
  SEMINAR_MENUS,
  TAX_PORTAL_MENUS,
  GLOVAL_MENUS,
  PAY_PORTAL_MENUS,
} from "../../constants/MENU";
import Icon from "../../components/Icon";
import { isAdminCompany, isManagerCompany } from "../../utils/auth";
import { classnames } from "../../utils/text";
import { isEmpty } from "../../utils/lodashExtend";
import { useSelector } from "react-redux";
import setTrialType from "../../utils/trial";
import { newWindow } from "../../utils/browser";
import systemAlert from "../../utils/systemAlert";

//Simple bar
import SimpleBar from "simplebar-react";

const MenuItem = ({ menu, company, isSub, role }) => {

  const isTrial = useMemo(() => {
    return company && company.isTrial && !menu.isTrial;
  }, [company, menu]);

  const isSoon = useMemo(() => {
    return menu.isSoon || (menu.isDev && process.env.REACT_APP_MODE !== 'dev');
  }, [menu]);

  const isFree = useMemo(() => {
    return company && company.isFree && !menu.isFree;
  }, [company, menu]);

  const isRole = useMemo(() => {
    if (!isEmpty(menu.roles) && company) {
      return !(menu.roles.includes(role.type) || company.employeeIdx === 878);
    } else {
      return false;
    }
  }, [menu.roles, role, company]);

  return (
    <li key={menu.label} className={classnames({
      hide: (menu.isHide && !menu.isShow && !(isTrial)) || isRole,
      trial: isFree || isTrial
    })}>
      {isFree || isTrial ?
        <>
          {/* <a
            onClick={() => !(!menu.badge && menu.children) && setTrialType(menu.id)}
            className={
              "waves-effect" + (!menu.badge && menu.children ? " has-arrow" : "")
            }
          > */}

          <a
            // to={menu.path || "/#"}
            onClick={() => !(!menu.badge && menu.children) && setTrialType(menu.id)}
            className={
              "waves-effect" + (!menu.badge && menu.children ? " has-arrow" : "")
            }
          >
            {menu.icon && (menu.icon.indexOf('bxs') === -1) ? <Icon src={menu.icon} className="menu-icon" /> : <i className={'menu-icon icon ' + menu.icon}></i>}
            {/*{menu.onIcon && (menu.onIcon.indexOf('bxs') === -1) ? <Icon src={menu.onIcon} className="menu-icon on-icon" /> : <i className={'menu-icon on-icon icon ' + menu.onIcon}></i>} */}
            <i className={'menu-icon hover-icon icon bx bx-lock-alt'}></i>
            {menu.badge && (
              <span className="badge badge-pill badge-info float-right">03</span>
            )}
            <span className="menu-label">
              {menu.label}
            </span>
          </a>
          {/* </a> */}
          {menu.children && (
            <ul className="sub-menu" aria-expanded="true" height="ayto">
              {menu.children.map((subMenu, idx) => (
                <MenuItem
                  isSub={true}
                  key={idx}
                  company={company}
                  menu={{ ...subMenu, isTrial: false, id: menu.id }}
                  role={role}
                />

              ))}
            </ul>
          )}
        </>
        :
        <>
          {isSoon ? <>
            <a
              onClick={() => systemAlert(
                `이 기능은 현재 준비 중입니다.
해당 서비스를 빠른 시일 내에 제공하도록 하겠습니다. 

감사합니다.`
              )}
              className={
                "waves-effect" + (!menu.badge && menu.children && !isSoon ? " has-arrow" : "")
              }
            >
              {menu.icon && (menu.icon.indexOf('bxs') === -1) ? <Icon src={menu.icon} width="20px" className="menu-icon" /> : <i className={'menu-icon icon ' + menu.icon}></i>}
              {/*{menu.onIcon && (menu.onIcon.indexOf('bxs') === -1) ? <Icon src={menu.onIcon} className="menu-icon on-icon" /> : <i className={'menu-icon on-icon icon ' + menu.onIcon}></i>} */}
              {/* <i className={'menu-icon hover-icon icon bx bx-lock-alt'}></i> */}
              {menu.badge && (
                <span className="badge badge-pill badge-info float-right">03</span>
              )}
              <span className="menu-label">
                {menu.label}
              </span>
              {(
                <span className="color-red-100 font-size-8 ml-8">
                  soon
                </span>
              )}
            </a>
          </> : <>
            {menu.link ? <>
              <a
                href={menu.link}
                // eslint-disable-next-line react/jsx-no-target-blank
                target="_blank"
                className={
                  "waves-effect" + (!menu.badge && menu.children ? " has-arrow" : "")
                }
              >
                {menu.icon && (menu.icon.indexOf('bxs') === -1) ? <Icon src={menu.icon} className="menu-icon" /> : <i className={'menu-icon icon ' + menu.icon}></i>}
                <span className="menu-label">
                  {menu.label}
                </span>
              </a>
            </> : <>
              {menu.action ? <>
                <a
                  onClick={menu.action}
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                  className={
                    "waves-effect" + (!menu.badge && menu.children ? " has-arrow" : "")
                  }
                >
                  {menu.icon && (menu.icon.indexOf('bxs') === -1) ? <Icon src={menu.icon} className="menu-icon" /> : <i className={'menu-icon icon ' + menu.icon}></i>}
                  <span className="menu-label">
                    {menu.label}
                  </span>
                </a>
              </> : <><Link
                to={menu.path || "/#"}
                className={
                  "waves-effect" + (!menu.badge && menu.children ? " has-arrow" : "")
                }
              >
                {menu.icon && (menu.icon.indexOf('bxs') === -1) ? <Icon src={menu.icon} className="menu-icon" /> : <i className={'menu-icon icon ' + menu.icon}></i>}
                {menu.onIcon && (menu.onIcon.indexOf('bxs') === -1) ? <Icon src={menu.onIcon} className="menu-icon on-icon" /> : <i className={'menu-icon on-icon icon ' + menu.onIcon}></i>}
                {menu.badge && (
                  <span className="badge badge-pill badge-info float-right">03</span>
                )}
                <span className="menu-label">
                  {menu.label}
                </span>
                {
                  !(!menu.badge && menu.children) && <img onClick={(e) => newWindow(menu.path, e)} src="/images/new-window-icon.png" className="new-window-icon" alt="새창" />
                }

              </Link></>}
            </>


            }
          </>}
          {menu.children && !isSoon && (
            <ul className="sub-menu" aria-expanded="true">
              {menu.children.map((subMenu, idx) => <MenuItem key={idx} menu={subMenu} role={role} company={company} />)}
            </ul>
          )}
        </>
      }
    </li>
  );
};

const getItems = (item) => {
  if (item.parentElement.classList.contains('metismenu')) {
    return item;
  } else {
    return getItems(item.parentElement);
  }
};

const SidebarContent = (props) => {
  const { company, managerRole: role } = useSelector((store) => store.Profile);
  const [menus, setMenus] = useState([]);
  const [trialMenus, setTrialMenus] = useState([]);
  const [menuMode, setMenuMode] = useState('BIZ'); // TAX_PORTAL, BIZ
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  const initMenu = (pathName) => {
    new MetisMenu("#side-menu");
    const items = document.querySelectorAll("#side-menu a");
    const matchingMenuItem = Array.from(items).find(item => pathName === item.pathname);
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  };

  const [showTrialMenus, setShowTrialMenus] = useState(false);


  useEffect(() => {
    var pathName = props.location.pathname;
    if (!isEmpty(menus)) {
      initMenu(pathName);
      //console.log('menus', menus)
    }
  }, [props.location.pathname, menus, menuMode]);

  useEffect(() => {
    if (!isEmpty(company)) {
      setMenus([]);
      setTrialMenus([]);
      setTimeout(() => {
        setMenus(MENUS.filter((menu) => !(company && ((company.isFree && !menu.isFree) || (company.isTrial && !menu.isTrial)))));
        setTrialMenus(MENUS.filter((menu) => company && ((company.isFree && !menu.isFree) || (company.isTrial && !menu.isTrial))));
      }, 100);

    }
  }, [MENUS, company]);

  useEffect(() => {
    // if (process.env.REACT_APP_MODE === "dev") {
    //   // 개발 서버인 경우 TAX_PORTAL로 진입되도록
    //   setMenuMode('TAX_PORTAL');
    // }
    const isTaxPortal = props.location.pathname.includes('/tax-portal');
    const isPay = props.location.pathname.includes('/pay-portal');

    if (isTaxPortal) setMenuMode('TAX_PORTAL');
    else if (isPay) setMenuMode('PAY_PORTAL');
    else setMenuMode('BIZ');


  }, []);


  function activateParentDropdown(item) {

    // document.querySelectorAll('#side-menu .active-menu')
    //   .forEach((item) => {
    //     item.classList.remove('mm-active')
    //     item.classList.remove('active-menu')
    //   })
    document.querySelectorAll('#side-menu .active')
      .forEach((item) => {
        item.classList.remove('active');
      });


    if (item.pathname === "/dashboard") {
      item.classList.add("mm-active");
    } else {
      item.classList.add("active");
    }

    const parent = item.parentElement;

    // menu focus scroll
    const menuHiehgt = document.querySelectorAll('.lnb-wrap')[0].offsetHeight;
    if (menuHiehgt - 300 < getItems(item).offsetTop) {
      document.querySelectorAll('.simplebar-content-wrapper')[0].scrollTop = getItems(item).offsetTop;


    }

    if (parent) {
      parent.classList.add("mm-active");
      parent.classList.add("active-menu");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.classList.add("active-menu");

          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  }

  return (
    <React.Fragment>
      <div id="sidebar-menu">

        {
          isManagerCompany() &&
          <div className="" id="global-menu">
            {
              GLOVAL_MENUS.map(({ id, label, isBeta, isSoon, isDev }, idx) => <a
                key={idx}
                onClick={() => isSoon || (isDev && process.env.REACT_APP_MODE !== 'dev') ? systemAlert(
                  `이 기능은 현재 준비 중입니다.
해당 서비스를 빠른 시일 내에 제공하도록 하겠습니다. 

감사합니다.`
                ) : setMenuMode(id)}
                className={classnames({
                  active: id === menuMode,
                }, "global-menu-item", `global-menu-item-${id}`)}
              >
                {label}
                {isBeta && <span className="beta-icon">beta</span>}
                {(isSoon || (isDev)) && <span className="beta-icon">soon</span>}
              </a>
              )
            }
          </div>
        }

        <SimpleBar style={{ maxHeight: "100%" }}>

          <ul className="metismenu list-unstyled" id="side-menu">
            {menuMode === 'TAX_PORTAL' &&
              isManagerCompany() &&
              TAX_PORTAL_MENUS.map((menu, idx) => <MenuItem key={idx} company={company} menu={menu} role={role} />)
            }
            {menuMode === 'PAY_PORTAL' &&
              isManagerCompany() &&
              PAY_PORTAL_MENUS.map((menu, idx) => <MenuItem key={idx} company={company} menu={menu} role={role} />)
            }
            {menuMode === 'BIZ' && !isEmpty(menus) &&
              <>
                {
                  isAdminCompany() &&
                  ADMIN_MENUS.map((menu, idx) => <MenuItem key={idx} company={company} menu={menu} role={role} />)
                }
                {
                  isAdminCompany() &&
                  HOMEPAGE_MENUS.map((menu, idx) => <MenuItem key={idx} company={company} menu={menu} role={role} />)
                }
                {
                  isAdminCompany() &&
                  SEMINAR_MENUS.map((menu, idx) => <MenuItem key={idx} company={company} menu={menu} role={role} />)
                }
                {
                  isManagerCompany() &&
                  MANAGER_MENUS.map((menu, idx) => <MenuItem key={idx} company={company} menu={menu} role={role} />)
                }
                {
                  process.env.REACT_APP_MODE === "dev" &&
                  DEV_MENUS.map((menu, idx) => <MenuItem key={idx} company={company} menu={menu} role={role} />)
                }

                {
                  menus.map((menu, idx) => <MenuItem key={idx} company={company} menu={menu} role={role} />)
                }
                {
                  !isEmpty(trialMenus) &&
                  <>

                    <li className={classnames('show-all-menu')}>
                      <a onClick={() => setShowTrialMenus(!showTrialMenus)}>
                        <span className="menu-label">
                          풀버전 전체 메뉴 {showTrialMenus ? '가리기' : '보기'}
                        </span>
                      </a>
                    </li>
                    {showTrialMenus && trialMenus.map((menu, idx) => <MenuItem key={idx} company={company} menu={menu} role={role} />)}
                  </>
                }
              </>}
          </ul>
        </SimpleBar>
      </div>
    </React.Fragment>
  );
};

export default withRouter(withNamespaces()(SidebarContent));
